import React, { useEffect, useState } from "react";
import { Outlet, NavLink, useNavigate, useLocation } from "react-router-dom";
import { clearAuth, getUser } from "../../utils/auth";
import {
  FiLogOut,
  FiMenu,
  FiX,
  FiGrid,
  FiUsers,
  FiSettings,
  FiClipboard,
  FiUserCheck,
  FiFileText,
  FiCalendar,
  FiChevronDown,
  FiUser,
} from "react-icons/fi";
import { RiUser2Fill, RiUserFill } from "react-icons/ri";

const navItems = [
  { path: "/dashboard", label: "Dashboard", icon: FiGrid },
  { path: "/operators", label: "Operators", icon: FiUserCheck },
  { path: "/leads", label: "Leads", icon: FiClipboard },
  { path: "/demos", label: "Demo", icon: FiFileText },
  { path: "/attendance", label: "Attendance", icon: FiCalendar },
  { path: "/audit", label: "Audit Logs", icon: FiFileText },
  { path: "/users", label: "Users", icon: FiUsers },
  { path: "/config", label: "Config", icon: FiSettings },
];

const useIsMobile = (breakpoint = 768) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= breakpoint);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= breakpoint);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [breakpoint]);

  return isMobile;
};

const s = {
  app: {
    display: "flex",
    height: "100vh",
    overflow: "hidden",
    background: "#f8fafc",
  },
  mobileBackdrop: {
    position: "fixed",
    inset: 0,
    background: "rgba(15, 23, 42, 0.45)",
    zIndex: 998,
  },
  sidebar: {
    width: 220,
    height: "100vh",
    background: "#1e293b",
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    padding: "20px 0",
    flexShrink: 0,
    transition: "width 0.3s ease, left 0.3s ease",
  },
  sidebarCollapsed: {
    width: 76,
  },
  brandRow: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "0 20px 24px",
    borderBottom: "1px solid #334155",
    height: 35,
  },
  logoRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  brandText: {
    fontSize: 18,
    fontWeight: 700,
    color: "#fff",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
  sidebarCloseBtn: {
    marginLeft: "auto",
    width: 30,
    height: 30,
    border: "none",
    borderRadius: 8,
    background: "rgba(255,255,255,0.08)",
    color: "#fff",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  nav: {
    flex: 1,
    padding: "16px 0",
    overflowY: "auto",
  },
  link: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "10px 20px",
    color: "#94a3b8",
    textDecoration: "none",
    fontSize: 14,
    transition: "all 0.2s ease",
  },
  activeLink: {
    color: "#fff",
    background: "#334155",
    borderLeft: "3px solid #534ab7",
  },
  footer: {
    height: 80,
    padding: "16px 20px",
    borderTop: "1px solid #334155",
    fontSize: 13,
    color: "#64748b",
  },
  logout: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    color: "#f87171",
    cursor: "pointer",
    fontSize: 14,
    fontWeight: 500,
    padding: "8px 10px",
    borderRadius: 8,
    transition: "0.2s ease",
  },
  logoutHover: {
    background: "rgba(248,113,113,0.1)",
  },
  main: {
    flex: 1,
    height: "100vh",
    overflow: "hidden",
    boxSizing: "border-box",
  },
  headerName: {
    position: "relative",
  },

  profileToggle: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    border: "none",
    borderRadius: 10,
    padding: "8px 12px",
    cursor: "pointer",
    color: "#1e293b",
    fontSize: 14,
    fontWeight: 500,
  },

  profileDropdown: {
    position: "absolute",
    top: 44,
    right: 0,
    width: 220,
    background: "#fff",
    border: "1px solid #e2e8f0",
    borderRadius: 12,
    boxShadow: "0 12px 30px rgba(15, 23, 42, 0.14)",
    padding: 10,
    zIndex: 50,
  },

  profileInfo: {
    padding: "10px 10px 12px",
    borderBottom: "1px solid #e2e8f0",
    marginBottom: 8,
  },

  profileTop: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 10,
  },

  profileName: {
    fontSize: 15,
    fontWeight: 700,
    color: "#1e293b",
  },

  profileRole: {
    fontSize: 12,
    fontWeight: 600,
    color: "#534AB7",
    textTransform: "capitalize",
    background: "#f1f0ff",
    padding: "3px 8px",
    borderRadius: 999,
  },

  dropdownBtn: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "9px 10px",
    border: "none",
    background: "transparent",
    borderRadius: 8,
    cursor: "pointer",
    fontSize: 14,
    fontWeight: 600,
    color: "#334155",
    textAlign: "left",
  },

  dropdownLogout: {
    color: "#ef4444",
  },
  header: {
    height: 56,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 20px",
    background: "#fff",
    borderBottom: "1px solid #e2e8f0",
    position: "sticky",
    top: 0,
    zIndex: 50,
  },
  headerMenuBtn: {
    background: "transparent",
    border: "none",
    color: "#1e293b",
    cursor: "pointer",
    fontSize: 20,
    padding: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 34,
    height: 34,
    borderRadius: 8,
    flexShrink: 0,
  },
  menuIcon: {
    width: 20,
    height: 14,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },

  menuLine: {
    height: 2,
    width: "100%",
    background: "#1e293b",
    borderRadius: 2,
    transition: "all 0.3s ease",
  },

  menuLine1Active: {
    transform: "rotate(45deg) translate(4px, 4px)",
  },

  menuLine2Active: {
    opacity: 0,
  },

  menuLine3Active: {
    transform: "rotate(-45deg) translate(4px, -4px)",
  },
  content: {
    height: "calc(100vh - 56px)",
    padding: 28,
    overflowY: "auto",
    boxSizing: "border-box",
  },
  footerName: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    fontSize: 18,
    fontWeight: 500,
    color: "#fff",
    marginBottom: 12,
  },
  FooterRole: {
    textTransform: "capitalize",
    color: "#60a5fa",
    fontSize: 12,
  },
  headerName: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    fontWeight: 500,
    color: "#1e293b",
  },

  headerRole: {
    fontSize: 12,
    color: "#64748b",
    textTransform: "capitalize",
  },
};

export default function Layout() {
  const navigate = useNavigate();
  const user = getUser();
  const [hoverLogout, setHoverLogout] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const isMobile = useIsMobile();
  const [profileOpen, setProfileOpen] = useState(false);
  const location = useLocation();
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    if (isMobile) {
      setCollapsed(true);
    } else {
      setCollapsed(false);
    }
  }, [isMobile]);

  const handleLogout = () => {
    clearAuth();
    navigate("/login");
  };

  return (
    <div style={s.app}>
      {isMobile && !collapsed && (
        <div style={s.mobileBackdrop} onClick={() => setCollapsed(true)} />
      )}

      <aside
        style={{
          ...s.sidebar,
          ...(collapsed ? s.sidebarCollapsed : {}),
          ...(isMobile
            ? {
                position: "fixed",
                top: 0,
                left: collapsed ? -240 : 0,
                width: 220,
                zIndex: 999,
                boxShadow: "4px 0 18px rgba(15,23,42,0.22)",
                transition: "left 0.3s ease",
              }
            : {}),
        }}
      >
        <div style={s.brandRow}>
          <div style={s.logoRow}>
            <svg
              width="25"
              height="25"
              viewBox="0 0 36 36"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-label="Sales Tracker Logo"
            >
              <rect width="36" height="36" rx="10" fill="#534AB7" />
              <path
                d="M10 25V16"
                stroke="white"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M18 25V11"
                stroke="white"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M26 25V19"
                stroke="white"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M9 26H27"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </div>

          {(!collapsed || isMobile) && (
            <div style={s.brandText}>Sales Tracker</div>
          )}

          {isMobile && (
            <button
              type="button"
              style={s.sidebarCloseBtn}
              onClick={() => setCollapsed(true)}
              aria-label="Close sidebar"
            >
              <FiX size={16} />
            </button>
          )}
        </div>

        <nav style={s.nav}>
          {navItems.map((item) => {
            const Icon = item.icon;

            return (
              <NavLink
                key={item.path}
                to={item.path}
                title={collapsed ? item.label : ""}
                onClick={(e) => {
                  if (location.pathname === item.path) {
                    e.preventDefault();
                    setRefreshKey((prev) => prev + 1);
                  }

                  if (isMobile) {
                    setCollapsed(true);
                  }
                }}
                style={({ isActive }) => ({
                  ...s.link,
                  justifyContent: collapsed ? "center" : "flex-start",
                  ...(isActive ? s.activeLink : {}),
                })}
              >
                <Icon size={16} />
                {!collapsed && <span>{item.label}</span>}
              </NavLink>
            );
          })}
        </nav>

        <div style={s.footer}>
          {!collapsed && (
            <div style={s.footerName}>
              {user?.name}
              <div style={s.FooterRole}>{user?.role}</div>
            </div>
          )}

          <div
            title={collapsed ? "Logout" : ""}
            style={{
              ...s.logout,
              justifyContent: collapsed ? "center" : "flex-start",
              ...(hoverLogout ? s.logoutHover : {}),
            }}
            onMouseEnter={() => setHoverLogout(true)}
            onMouseLeave={() => setHoverLogout(false)}
            onClick={handleLogout}
          >
            <FiLogOut size={16} />
            {!collapsed && <span>Logout</span>}
          </div>
        </div>
      </aside>

      <main
        style={{
          ...s.main,
          ...(isMobile ? { width: "100%" } : {}),
        }}
      >
        <div
          style={{
            ...s.header,
            ...(isMobile ? { padding: "0 12px" } : {}),
          }}
        >
          <button
            type="button"
            style={s.headerMenuBtn}
            onClick={() => setCollapsed((prev) => !prev)}
          >
            <div style={s.menuIcon}>
              <span
                style={{
                  ...s.menuLine,
                  ...(!isMobile && collapsed ? s.menuLine1Active : {}),
                }}
              />
              <span
                style={{
                  ...s.menuLine,
                  ...(!isMobile && collapsed ? s.menuLine2Active : {}),
                }}
              />
              <span
                style={{
                  ...s.menuLine,
                  ...(!isMobile && collapsed ? s.menuLine3Active : {}),
                }}
              />
            </div>
          </button>
          <div style={s.headerName}>
            <button
              type="button"
              style={{
                ...s.profileToggle,
                ...(isMobile ? { padding: "8px 10px", maxWidth: 170 } : {}),
              }}
              onClick={() => setProfileOpen((prev) => !prev)}
            >
              <span
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {user?.name}
              </span>
              <FiChevronDown size={16} />
            </button>

            {profileOpen && (
              <div
                style={{
                  ...s.profileDropdown,
                  ...(isMobile ? { right: 0, width: 210 } : {}),
                }}
              >
                <div style={s.profileInfo}>
                  <div style={s.profileTop}>
                    <div style={s.profileName}>{user?.name}</div>
                    <div style={s.profileRole}>{user?.role}</div>
                  </div>
                </div>

                <button
                  type="button"
                  style={s.dropdownBtn}
                  onClick={() => {
                    setProfileOpen(false);
                    navigate("/user/profile");
                  }}
                >
                  <FiUser size={16} />
                  <span>Profile</span>
                </button>

                <button
                  type="button"
                  style={{
                    ...s.dropdownBtn,
                    ...s.dropdownLogout,
                  }}
                  onClick={handleLogout}
                >
                  <FiLogOut size={16} />
                  <span>Logout</span>
                </button>
              </div>
            )}
          </div>
        </div>

        <div
          style={{
            ...s.content,
            ...(isMobile ? { padding: 14 } : {}),
          }}
        >
          <Outlet key={`${location.pathname}-${refreshKey}`} />
        </div>
      </main>
    </div>
  );
}
